import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrowright.svg";
import { ReactComponent as LinkOpen } from "../../../assets/icons/links.svg";
import { ReactComponent as Spinner } from "../../../assets/icons/spinner.svg";
import { ReactComponent as Man } from "../../../assets/images/signUp/man.svg";
import { SideSVG } from "../../common";
import { useVerificationMutation } from "../../../store/auth/usersApiSlice";
import { validateEmail } from "../../../utils/Helper";
import ReactGA from "react-ga4";

const Email = ({ onNext, onEmail }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setEmail(onEmail)
  }, [onEmail])

  const [verify, { isLoading }] = useVerificationMutation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    ReactGA.event({
      category: 'Create New Account',
      action: 'Create New Account',
      label: `Clicked on Verify Email; ${email.replace(/@/g, '=')}`,
    });
    try {
      if (!validateEmail(email)) {
        setError("Invalid Email, Please enter a valid email")
      } else {
        const res = await verify({
          email: email,
        }).unwrap();

        if (res?.status) {
          if (res?.status === "OTP_SENT") {
            // use global toster here
            onNext(email, res?.encrypted);
          } else {
            console.error("res Error:", res);
            setError(res?.message)
          }
        } else {
          setError("Something Went Wrong")
        }
      }

      // if (code) {
      //   onNext(email, code);
      // }
    } catch (error) {
      console.error("Error:", error);
      setError(
        error?.data
          ? Object.values(error?.data)[0]
          : "An error occurred. Please try again later."
      );
    }
  };

  return (
    <section className="relative pt-28 px-5 sm:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <div className=" absolute -top-24 left-8 align-center sm:top-5 sm:relative"><Logo /></div>
          <div className="flex flex-wrap -mx-4 xl:items-center items-center py">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md lg:py-20 mx-auto ">
                <h3 className="font-headi text-f16 ng sm:text-h3 text-primary font-bold mb-4 text-center">
                  Create Your Free Account
                </h3>
                <p className="text-lg text-secondary mb-10 text-center text-f14 sm:text-para3">
                  100% free. No credit card needed.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label
                      className="block mb-1.5 text-sm text-secondarytwo font-semibold text-left"
                      htmlFor="email_address"
                    >
                      Email address
                    </label>
                    <input
                      className="w-full py-3 px-4 text-sm text-primary placeholder-gray-400 border-b-2 border-primary focus:border-primary focus:outline-none focus:bg-white"
                      type="email"
                      id="email_address"
                      value={email}
                      required
                      disabled={onEmail}
                      onChange={onEmail ? null : (e) => {
                        setEmail((e?.target?.value)?.toLowerCase());
                      }}
                    />
                  </div>
                  {error && (
                    <div className="text-left text-red-500 mb-5">{error}</div>
                  )}
                  <button
                    className="relative group w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center mr-2 gap-4"
                    type="submit"
                  >
                    <span className="relative">
                      {isLoading ? <Spinner /> : "Verify Email"}
                    </span>
                    <ArrowRight />
                  </button>
                </form>
                <p className="text-secondary">
                  At TREVEX, we prioritize your privacy. We utilize the
                  information you share with us to reach out to you regarding
                  our valuable content, exceptional products, and top-notch
                  services. Rest assured, you can opt out of receiving these
                  communications at any time. For detailed insights, kindly
                  refer to our{" "}
                  <Link
                    to={'/privacy-policy'}
                    className="inline-flex items-center justify-center mr-2 gap-2 text-primaryText font-semibold"
                  >
                    {" "}
                    <span>Privacy Policy </span> <LinkOpen />
                  </Link>
                </p>
              </div>
            </div>
            <SideSVG SVG={Man} positions="bottom-0  left-[-25%] pjk" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Email;
